import React from "react";
import styled from "styled-components";
import { FaLaptop, FaMoneyCheckAlt, FaUsers, FaCloud, FaTools, FaCogs } from "react-icons/fa";

export default function WhyChooseChamaFlow() {
  return (
    <Section>
      <Container>
        <Title>Why Choose ChamaFlow?</Title>
        <Intro>
          ChamaFlow is a powerful, easy-to-use desktop app designed for Chamas and MFIs to manage all group finances and operations — from member records to loans and dividends.
        </Intro>

        <FeaturesGrid>
          <FeatureCard>
            <FaUsers size={32} color="purple" />
            <h4>Purpose-Built for Groups</h4>
            <p>
              Designed for grassroots financial groups. Easily manage loans, dividends, contributions, and financial reports.
            </p>
          </FeatureCard>

          <FeatureCard>
            <FaLaptop size={32} color="purple" />
            <h4>Offline Desktop App</h4>
            <p>
              Native Windows app that works without internet. No browser needed. Always accessible, even in remote areas.
            </p>
          </FeatureCard>

          <FeatureCard>
            <FaCloud size={32} color="purple" />
            <h4>Flexible Editions</h4>
            <p>
              Choose Solo, Team (LAN), or Cloud editions to suit individual users, teams, or growing organizations.
            </p>
          </FeatureCard>

          <FeatureCard>
            <FaMoneyCheckAlt size={32} color="purple" />
            <h4>One-Time License</h4>
            <p>
              No monthly subscriptions. Just a single payment to own your software — budget-friendly and transparent.
            </p>
          </FeatureCard>

          <FeatureCard>
            <FaTools size={32} color="purple" />
            <h4>Feature-Rich</h4>
            <p>
              Membership, loans, accounting, contributions, multi-group support, reports, and more — all in one app.
            </p>
          </FeatureCard>

          <FeatureCard>
            <FaCogs size={32} color="purple" />
            <h4>API & SMS Integration</h4>
            <p>
              Integrate MPESA and SMS tools easily to communicate and transact with members in real time.
            </p>
          </FeatureCard>
        </FeaturesGrid>

        <ClosingText>
          Already helping groups transition from paper to powerful digital tools. ChamaFlow is your smart, affordable solution for structured financial management.
        </ClosingText>
      </Container>
    </Section>
  );
}

const Section = styled.section`
  padding: 60px 20px;
  background-color: #f9f9f9;
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const Title = styled.h2`
  text-align: center;
  font-size: 32px;
  margin-bottom: 20px;
  color: #333;
`;

const Intro = styled.p`
  text-align: center;
  font-size: 18px;
  max-width: 700px;
  margin: 0 auto 40px;
  color: #666;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
`;

const FeatureCard = styled.div`
  background: white;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  h4 {
    margin: 15px 0 10px;
    font-size: 18px;
    color: #222;
  }

  p {
    color: #555;
    font-size: 15px;
  }
`;

const ClosingText = styled.p`
  text-align: center;
  font-size: 18px;
  margin-top: 50px;
  color: #444;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
`;
